import React from 'react';
import { useIntl } from 'react-intl';

import { Grid } from '@material-ui/core';
import { Info } from '@material-ui/icons';
import { SdmTextButton } from 'components';
import translations from 'utils/translations';
import { theme } from 'theme';
import {
  AccordionNameEnum,
  ParagraphEnum,
  PathInfoImages,
} from 'utils/drupalEntities';

const nameMapping = {
  [ParagraphEnum.SD_BRAND_MULTITEXT]: 'textBlock',
  [ParagraphEnum.SLIDER_DETAIL]: 'detailSlider',
  [ParagraphEnum.YOUTUBE_VIDEO]: 'youtubeVideo',
  [ParagraphEnum.VIMEO_VIDEO]: 'vimeoVideo',
  [ParagraphEnum.VIRTUAL_SHOWROOM]: 'virtualShowroom',
  [ParagraphEnum.SDM_QUOTED_TEXT]: 'quote',
  [ParagraphEnum.TITLE_SECTION]: 'title',
  [ParagraphEnum.DESIGNER]: 'designer',
  [ParagraphEnum.FREE_IMAGE]: 'image',
  [ParagraphEnum.TECHNICAL_SHEET]: 'technicalSheet',
  [ParagraphEnum.FREE_IMAGE_FULL_SCREEN]: 'fullScreenImage',
};

const capitalize = (s) =>
  (s && s[0].toUpperCase() + s.toLowerCase().slice(1)) || '';

const Controls = ({
  handleAddComponents,
  buttons,
  setInfoDialog,
  langCode,
  fields,
  isExhibitorGold = false,
}) => {
  const intl = useIntl();
  const i18n = translations.productPage(intl);
  const hasTechSheet = fields?.find(
    (f) => f.name === ParagraphEnum.TECHNICAL_SHEET
  );
  const handleInfo = (key) =>
    setInfoDialog({
      i18n: { title: capitalize(i18n.titles[nameMapping[key]]) },
      isOpen: true,
      img: PathInfoImages(langCode)?.[AccordionNameEnum.ADDITIONAL]?.[key],
    });

  return (
    <Grid container spacing={1}>
      {buttons
        .filter((b) => {
          return hasTechSheet
            ? b !== ParagraphEnum.TECHNICAL_SHEET
            : !isExhibitorGold
            ? b !== ParagraphEnum.VIRTUAL_SHOWROOM
            : b;
        })
        .map((b, idx) => (
          <Grid item xs={6} spacing={3} key={idx}>
            <SdmTextButton
              onClick={(e) => handleAddComponents(e, b)}
              text={i18n.buttons[b]}
              style={{ width: '100%', margin: 0 }}
              variant="black"
              textVariant="h5Regular"
              positionArrowPx={15}
              positionArrowTop={0}
              customStyle={{
                display: 'flex',
                alignItems: 'center',
              }}
            >
              <Info
                style={{
                  height: '25px',
                  color: theme.colors.primary.grey,
                  cursor: 'pointer',
                }}
                className="prevent-btn-info"
                onClick={() => handleInfo(b)}
              />
            </SdmTextButton>
          </Grid>
        ))}
    </Grid>
  );
};

export default Controls;
